import GenericPropertiesControl from './GenericPropertiesControl';
import { useRiskareaPropertiesStore } from '../../../store/useGeometryPropertiesStore';

const RiskareaPropertiesControl = () => {
  const store = useRiskareaPropertiesStore();
  
  const properties = [
    { key: 'objectId', label: 'Objekt-ID', value: store.objectId },
    { key: 'waterType', label: 'Gewässertyp', value: store.waterType },
    { key: 'waterName', label: 'Gewässername', value: store.waterName }
  ];

  const handlePropertyUpdate = (key, value) => {
    store.updateProperty(key, value);
  };

  return (
    <GenericPropertiesControl 
      properties={properties}
      onPropertyUpdate={handlePropertyUpdate}
      title="EIGENSCHAFTEN"
    />
  );
};

export default RiskareaPropertiesControl;